import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the current date in YYYY-MM-DD format based on the user's LOCAL system time.
 * Replaces new Date().toISOString() which uses UTC and causes wrong dates.
 */
export const getTodayDateString = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Formats a date string or object consistently without timezone shifts.
 * Handles YYYY-MM-DD strings by parsing components to local time.
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return '';
  
  // If the input is a standard HTML5 date string (YYYY-MM-DD)
  if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
    const [year, month, day] = dateInput.split('-').map(Number);
    // month - 1 because JS months are 0-indexed
    const localDate = new Date(year, month - 1, day);
    return localDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  // Fallback for Date objects or ISO strings
  const date = new Date(dateInput);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDuration = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0) {
    return `${hours}h ${mins}m`;
  }
  return `${mins}m`;
};

export const getPositionColor = (position) => {
  const colors = {
    'Guard': '#059669',
    'Mount': '#dc2626',
    'Side Control': '#d97706',
    'Back Control': '#7c2d12',
    'Half Guard': '#0891b2',
    'Turtle': '#7c3aed',
    'Standing': '#4338ca',
    'Knee on Belly': '#be185d',
    'Ashi Garami': '#16a34a',
    'Front Headlock': '#ea580c',
    'Leg Entanglements': '#8b5cf6',
    'North-South': '#6366f1'
  };
  return colors[position] || '#6b7280';
};